import React from 'react';
import { AdminLayout } from '../../components/layouts/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Users, FileCheck, AlertCircle, TrendingUp } from 'lucide-react';
import { toPersianDigits, formatCurrency } from '../../utils/persian';
export function AdminDashboard() {
  return <AdminLayout data-id="element-134">
      <div className="space-y-8" data-id="element-135">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-136">داشبورد مدیریت</h1>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-137">
          <Card data-id="element-138">
            <CardContent className="p-6 flex items-center gap-4" data-id="element-139">
              <div className="p-3 bg-blue-100 rounded-full text-blue-600" data-id="element-140">
                <Users className="h-6 w-6" data-id="element-141" />
              </div>
              <div data-id="element-142">
                <p className="text-sm text-gray-500 font-medium" data-id="element-143">کاربران کل</p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-144">
                  {toPersianDigits(1250)}
                </p>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-145">
            <CardContent className="p-6 flex items-center gap-4" data-id="element-146">
              <div className="p-3 bg-green-100 rounded-full text-green-600" data-id="element-147">
                <FileCheck className="h-6 w-6" data-id="element-148" />
              </div>
              <div data-id="element-149">
                <p className="text-sm text-gray-500 font-medium" data-id="element-150">
                  بیمه‌نامه‌های صادره
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-151">
                  {toPersianDigits(856)}
                </p>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-152">
            <CardContent className="p-6 flex items-center gap-4" data-id="element-153">
              <div className="p-3 bg-orange-100 rounded-full text-orange-600" data-id="element-154">
                <AlertCircle className="h-6 w-6" data-id="element-155" />
              </div>
              <div data-id="element-156">
                <p className="text-sm text-gray-500 font-medium" data-id="element-157">
                  خسارت‌های باز
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-158">
                  {toPersianDigits(12)}
                </p>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-159">
            <CardContent className="p-6 flex items-center gap-4" data-id="element-160">
              <div className="p-3 bg-purple-100 rounded-full text-purple-600" data-id="element-161">
                <TrendingUp className="h-6 w-6" data-id="element-162" />
              </div>
              <div data-id="element-163">
                <p className="text-sm text-gray-500 font-medium" data-id="element-164">
                  فروش ماه جاری
                </p>
                <p className="text-xl font-bold text-gray-900" data-id="element-165">
                  {toPersianDigits('450,000,000')}{' '}
                  <span className="text-xs text-gray-500" data-id="element-166">ریال</span>
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Recent Activity */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-167">
          <Card data-id="element-168">
            <CardHeader data-id="element-169">
              <CardTitle className="text-lg" data-id="element-170">
                آخرین بیمه‌نامه‌های صادر شده
              </CardTitle>
            </CardHeader>
            <CardContent data-id="element-171">
              <div className="space-y-4" data-id="element-172">
                {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center justify-between py-2 border-b last:border-0" data-id="element-173">
                    <div className="flex items-center gap-3" data-id="element-174">
                      <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center text-sm font-bold" data-id="element-175">
                        {toPersianDigits(i)}
                      </div>
                      <div data-id="element-176">
                        <p className="text-sm font-medium" data-id="element-177">
                          بیمه شخص ثالث - پژو ۲۰۶
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-178">
                          علی احمدی - {toPersianDigits('1403/02/15')}
                        </p>
                      </div>
                    </div>
                    <span className="text-sm font-medium text-green-600" data-id="element-179">
                      صادر شده
                    </span>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-180">
            <CardHeader data-id="element-181">
              <CardTitle className="text-lg" data-id="element-182">درخواست‌های خسارت اخیر</CardTitle>
            </CardHeader>
            <CardContent data-id="element-183">
              <div className="space-y-4" data-id="element-184">
                {[1, 2, 3].map(i => <div key={i} className="flex items-center justify-between py-2 border-b last:border-0" data-id="element-185">
                    <div className="flex items-center gap-3" data-id="element-186">
                      <div className="h-8 w-8 rounded-full bg-red-50 flex items-center justify-center text-red-600" data-id="element-187">
                        <AlertCircle className="h-4 w-4" data-id="element-188" />
                      </div>
                      <div data-id="element-189">
                        <p className="text-sm font-medium" data-id="element-190">
                          تصادف جرحی - پراید
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-191">
                          سارا محمدی - {toPersianDigits('1403/02/14')}
                        </p>
                      </div>
                    </div>
                    <span className="text-xs px-2 py-1 bg-orange-100 text-orange-700 rounded-full" data-id="element-192">
                      در حال بررسی
                    </span>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </AdminLayout>;
}